var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { CaseApplyManageService } from '~/services/business-service/case-apply-manage.service';
import { Emit, Prop } from 'vue-property-decorator';
import { PageService } from '~/utils/page.service';
import { SortService } from '~/utils/sort.service';
import { UserService } from '~/services/manage-service/user.service';
import DataBox from '~/components/common/data-box.vue';
import DepartmentTree from '~/components/system-manage/department-tree.vue';
var TurncasesApprovePending = /** @class */ (function (_super) {
    __extends(TurncasesApprovePending, _super);
    function TurncasesApprovePending() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectionList = [];
        _this.publiccaseDataSet = [];
        _this.SearchModel = {};
        _this.loading = {
            state: false
        };
        return _this;
    }
    TurncasesApprovePending.prototype.refreshList = function () { };
    TurncasesApprovePending.prototype.approvedMeth = function (rowData) { };
    TurncasesApprovePending.prototype.refreshData = function () {
        var _this = this;
        this.SearchModel = Object.assign(this.turnCaseModel);
        this.SearchModel.flowType = 'TEL_TO_VISIT';
        this.SearchModel.approvalStatus = 'WAIT_APPROVAL';
        this.SearchModel.applyDateStart = this.turnCaseModel.applyDate[0];
        this.SearchModel.applyDateEnd = this.turnCaseModel.applyDate[1];
        this.caseApplyManageService.getProcessApproveMessage(this.SearchModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.publiccaseDataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    //审批操作
    TurncasesApprovePending.prototype.approvedpubliccaseMeth = function (scope) {
        var rowData = scope.row;
        this.approvedMeth(rowData);
    };
    __decorate([
        Dependencies(PageService)
    ], TurncasesApprovePending.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], TurncasesApprovePending.prototype, "sortService", void 0);
    __decorate([
        Dependencies(UserService)
    ], TurncasesApprovePending.prototype, "userService", void 0);
    __decorate([
        Dependencies(CaseApplyManageService)
    ], TurncasesApprovePending.prototype, "caseApplyManageService", void 0);
    __decorate([
        Emit('refreshList')
    ], TurncasesApprovePending.prototype, "refreshList", null);
    __decorate([
        Emit('approvedMeth')
    ], TurncasesApprovePending.prototype, "approvedMeth", null);
    __decorate([
        Prop()
    ], TurncasesApprovePending.prototype, "turnCaseModel", void 0);
    TurncasesApprovePending = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                DepartmentTree: DepartmentTree,
            },
        })
    ], TurncasesApprovePending);
    return TurncasesApprovePending;
}(Vue));
export default TurncasesApprovePending;
